import { Component, Input } from "@angular/core";

import { CardsGroup } from "./card-group.type";

/** The card group component is used to display a group of the data related to each other. Mostly is used as table heading */
@Component({
  selector: "uni-cards-group",
  templateUrl: "./cards-group.component.html",
  styleUrls: ["./cards-group.component.scss"],
})
export class UniCardsGroupComponent {
  /**
   * List of the cards elements
   */
  @Input() public cardsGroup: CardsGroup;

  /**
   * If the title is inline or not
   */
  @Input() public inlineTitle = false;
}
